import React, { useState } from 'react';
import classnames from 'classnames';
import SEO from '@bradgarropy/gatsby-plugin-seo';

import Layout from '../components/layout';

const Pricing = () => {
  const [annual, setAnnual] = useState(true);
  return (
    <Layout>
      <SEO
        title='Pricing | Praiser'
        description='Boost your team moral by praising them'
      />
      <div className='px-5 py-24 text-gray-700 mx-auto'>
        <div className='flex flex-col text-center w-full mb-20'>
          <h1 className='sm:text-4xl text-3xl font-medium title-font mb-2 text-gray-900'>
            Pricing
          </h1>
          <p className='lg:w-2/3 mx-auto leading-relaxed text-base'>
            No credit card required.
          </p>
          <div className='flex mx-auto border-2 border-indigo-500 rounded overflow-hidden mt-6'>
            <button
              class={classnames('py-1 px-4 focus:outline-none', {
                'bg-indigo-500 text-white': !annual,
              })}
              onClick={() => setAnnual(false)}
            >
              Monthly
            </button>
            <button
              class={classnames('py-1 px-4 focus:outline-none', {
                'bg-indigo-500 text-white': annual,
              })}
              onClick={() => setAnnual(true)}
            >
              Annually
            </button>
          </div>
        </div>
        <div className='flex flex-wrap -m-4'>
          <div className='p-4 md:w-1/2 w-full'>
            <div className='h-full p-6 rounded-lg border-2 border-gray-300 flex flex-col relative overflow-hidden'>
              <h2 className='text-sm tracking-widest title-font mb-1 font-medium'>
                START
              </h2>
              <h1 className='text-5xl text-gray-900 pb-4 mb-4 border-b border-gray-200 leading-none'>
                Free
              </h1>
              <p className='flex items-center text-gray-600 mb-6'>
                <span className='w-4 h-4 mr-2 inline-flex items-center justify-center bg-gray-500 text-white rounded-full flex-shrink-0'>
                  <svg
                    fill='none'
                    stroke='currentColor'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2.5'
                    className='w-3 h-3'
                    viewBox='0 0 24 24'
                  >
                    <path d='M20 6L9 17l-5-5'></path>
                  </svg>
                </span>
                Praise members on public channel
              </p>
              <button className='flex items-center mt-auto text-white bg-gray-500 border-0 py-2 px-4 w-full focus:outline-none hover:bg-gray-600 rounded'>
                Signup
                <svg
                  fill='none'
                  stroke='currentColor'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth='2'
                  className='w-4 h-4 ml-auto'
                  viewBox='0 0 24 24'
                >
                  <path d='M5 12h14M12 5l7 7-7 7'></path>
                </svg>
              </button>
              <p className='text-xs text-gray-500 mt-3'>
                Literally you probably haven't heard of them jean shorts.
              </p>
            </div>
          </div>
          <div className='p-4 md:w-1/2 w-full'>
            <div className='h-full p-6 rounded-lg border-2 border-indigo-500 flex flex-col relative overflow-hidden'>
              <span className='bg-indigo-500 text-white px-3 py-1 tracking-widest text-xs absolute right-0 top-0 rounded-bl'>
                POPULAR
              </span>
              <h2 className='text-sm tracking-widest title-font mb-1 font-medium'>
                PRO
              </h2>
              <h1 className='text-5xl text-gray-900 leading-none flex items-center pb-4 mb-4 border-b border-gray-200'>
                <span>${annual ? 14 : 19}</span>
                <span className='text-lg ml-1 font-normal text-gray-500'>
                  <span>/mo</span>
                  {annual && (
                    <span className='ml-2 text-sm'>{`(Billed Annually)`}</span>
                  )}
                </span>
              </h1>
              <p className='flex items-center text-gray-600 mb-2'>
                <span className='w-4 h-4 mr-2 inline-flex items-center justify-center bg-gray-500 text-white rounded-full flex-shrink-0'>
                  <svg
                    fill='none'
                    stroke='currentColor'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2.5'
                    className='w-3 h-3'
                    viewBox='0 0 24 24'
                  >
                    <path d='M20 6L9 17l-5-5'></path>
                  </svg>
                </span>
                Praise members on private channel
              </p>
              <p className='flex items-center text-gray-600 mb-2'>
                <span className='w-4 h-4 mr-2 inline-flex items-center justify-center bg-gray-500 text-white rounded-full flex-shrink-0'>
                  <svg
                    fill='none'
                    stroke='currentColor'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2.5'
                    className='w-3 h-3'
                    viewBox='0 0 24 24'
                  >
                    <path d='M20 6L9 17l-5-5'></path>
                  </svg>
                </span>
                Configure who can praise
              </p>
              <p className='flex items-center text-gray-600 mb-6'>
                <span className='w-4 h-4 mr-2 inline-flex items-center justify-center bg-gray-500 text-white rounded-full flex-shrink-0'>
                  <svg
                    fill='none'
                    stroke='currentColor'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2.5'
                    className='w-3 h-3'
                    viewBox='0 0 24 24'
                  >
                    <path d='M20 6L9 17l-5-5'></path>
                  </svg>
                </span>
                Monthly leaderboard
              </p>
              <button className='flex items-center mt-auto text-white bg-indigo-500 border-0 py-2 px-4 w-full focus:outline-none hover:bg-indigo-600 rounded'>
                Try it for FREE for 30 days
                <svg
                  fill='none'
                  stroke='currentColor'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth='2'
                  className='w-4 h-4 ml-auto'
                  viewBox='0 0 24 24'
                >
                  <path d='M5 12h14M12 5l7 7-7 7'></path>
                </svg>
              </button>
              <p className='text-xs text-gray-500 mt-3'>
                Literally you probably haven't heard of them jean shorts.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Pricing;
